document.addEventListener('DOMContentLoaded', function() {
  const image = document.querySelector('.feature-image');
  const magnifyGlass = document.querySelector('.magnify-glass');

const glassSize = 200;
const halfGlass = glassSize / 2;

image.addEventListener('mousemove', function(e) {
  const rect = image.getBoundingClientRect();
  const x = e.clientX - rect.left;
  const y = e.clientY - rect.top;

  const glassX = Math.max(0, Math.min(x - halfGlass, rect.width - glassSize));
  const glassY = Math.max(0, Math.min(y - halfGlass, rect.height - glassSize));

  magnifyGlass.style.left = `${glassX}px`;
  magnifyGlass.style.top = `${glassY}px`;

  const bgX = (x / rect.width) * 100;
  const bgY = (y / rect.height) * 100;
  magnifyGlass.style.backgroundPosition = `${bgX}% ${bgY}%`;
});

  image.addEventListener('mouseenter', function() {
    magnifyGlass.style.display = 'block';
  });

  image.addEventListener('mouseleave', function() {
    magnifyGlass.style.display = 'none';
  });
});